import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path: 'label-sync-config',

  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const LabelSyncConfigContainer = require('./containers/LabelSyncConfigContainer').default
      const labelSyncConfigReducer = require('./modules/labelSyncConfig').default

      injectReducer(store, {
        key: 'labelSyncConfig',
        reducer: labelSyncConfigReducer
      })

      cb(null, LabelSyncConfigContainer)
    }, 'labelSyncConfig')
  }
})



// WEBPACK FOOTER //
// ./src/routes/LabelSyncConfig/index.js